import React from "react";
import { Switch, useRouteMatch } from "react-router-dom";
import PrivateRoute from "../../../../Routes/PrivateRoutes";
import EquipeProvider from "./EquipeContext";
import PesquisarEquipe from "./Events/PesquisarEquipe";
import FormularioEquipe from "./Events/FormularioEquipe";

const Index = () => {
  let match = useRouteMatch();
  return (
    <EquipeProvider>
      <div className="container-fluid pl-3 pt-3 pb-3">
        <Switch>
          <PrivateRoute
            exact
            path={`${match.url}`}
            component={PesquisarEquipe}
          />
          <PrivateRoute
            path={`${match.url}/:id`}
            component={FormularioEquipe}
          />
        </Switch>
      </div>
    </EquipeProvider>
  );
};

export default Index;
